const state = {
  campanhaSelec: null
}

const getters = {
  getCampanhaSelec: (state) => {
    return state.campanhaSelec
  }
}

const mutations = {
  setCampanhaSelec (state, value) {
    state.campanhaSelec = value
  }
}

const actions = {
}

export default { namespaced: true, state, mutations, actions, getters }
